import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { storeNames } from './config/config.type.ts';

interface DevSettingsState {
  forceScaleInternal: boolean;
}

interface DevSettingsStore extends DevSettingsState {
  setForceScaleInternal: (value: boolean) => void;
}

// Synchronously seed the initial value from localStorage so the flag is correct on the
// first render after a reload — before SiteProvider builds sites and TanStack Query fires.
// Relying on persist's rehydration alone can race those reads (same reason userSettings.ts
// pre-reads its persisted state).
const getPersistedForceScaleInternal = (): boolean => {
  try {
    const raw = localStorage.getItem(storeNames.devSettings);
    if (raw)
      return (JSON.parse(raw) as { state?: DevSettingsState }).state?.forceScaleInternal ?? false;
  } catch {
    // ignore malformed/unavailable storage
  }
  return false;
};

export const useDevSettingsStore = create(
  persist<DevSettingsStore>(
    set => ({
      forceScaleInternal: getPersistedForceScaleInternal(),
      setForceScaleInternal: (value: boolean) => set({ forceScaleInternal: value }),
    }),
    {
      name: storeNames.devSettings,
      storage: createJSONStorage(() => localStorage),
    }
  )
);
